import { Stack } from '@startuptools/ui/Stack';
import { Trans } from '@lingui/react';
import { Button } from '@startuptools/ui/joy/Button';
import Textarea from '@mui/joy/Textarea';
import { Controller } from 'react-hook-form';
import { FormHelperText } from '@startuptools/ui/joy/FormHelperText';
import { FormControl } from '@startuptools/ui/joy/FormControl';
import { FormLabel } from '@startuptools/ui/joy/FormLabel';
import { UpdateField } from '../UpdateField';
import { StepProps } from '../../types';

export const StepKindOfBusiness = ({ form, onSave, loading }: StepProps) => {
  return (
    <form
      onSubmit={form.handleSubmit(data =>
        onSave({
          changeKindOfBusiness: data.changeKindOfBusiness,
          kindOfBusiness: data.kindOfBusiness,
        }),
      )}
    >
      <Stack gap={2}>
        <Controller
          control={form.control}
          name="changeKindOfBusiness"
          key="changeKindOfBusiness"
          render={({ field }) => (
            <UpdateField value={field.value} onChange={field.onChange} label={<Trans id="description of business" />} />
          )}
        />

        <Controller
          control={form.control}
          name="kindOfBusiness"
          key="kindOfBusiness"
          rules={{
            required: true,
          }}
          render={({ field }) => (
            <FormControl error={!!form.formState.errors.kindOfBusiness}>
              <FormLabel>
                <Trans id="Description of business" />
              </FormLabel>
              <Textarea {...field} value={field.value ?? ''} minRows={3} sx={{ maxWidth: '600px' }} />
              {form.formState.errors.kindOfBusiness && (
                <FormHelperText>
                  {form.watch('changeKindOfBusiness') ? (
                    <Trans id="Required field" />
                  ) : (
                    <Trans id="Include the current description of business" />
                  )}
                </FormHelperText>
              )}
            </FormControl>
          )}
        />
        <Stack direction="row" justifyContent="flex-start">
          <Button type="submit" loading={loading}>
            <Trans id="Next" />
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
